import { AssembleiaAssessor, Error404, Logout, Main, MensagensAssessor, RelatorioPresentes, TransmissaoAssessor } from 'pages';
import HomeAssessor from 'pages/Assessor/Home';
import ConvocadosAssessor from 'pages/Assessor/Convocados';
import AssoicadoApp from 'pages/Associado';
import AssociadoLogin from 'pages/Associado/Auth';
import React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import PrivateRoute from './../components/PrivateRoute/PrivateRoute';
import IconsPage from 'components/Icons/IconsPage';
import VotoCanalVoz from 'pages/Assessor/VotoCanalVoz';
import EfetivacaoVotacao from 'pages/Assessor/EfetivacaoVotacao';

export interface IRoute {
  path?: string;
  component: any;
  exact?: boolean;
  render?: (props: RouteComponentProps) => React.ReactNode;
  private?: boolean;
}

export const basePath: string = '/assembleiadefundos/';

let routes: IRoute[] = [];

export const IconsRoutePath: string = basePath + 'icons/';
export const IconsRoute: IRoute = {
  path: IconsRoutePath,
  component: IconsPage,
  exact: true,
};
if (window.location.hostname === 'localhost') {
  routes.push(IconsRoute);
}

export const AssessorRoutePath: string = basePath + 'assessor/';
export const AssociadoRoutePath: string = basePath + 'associado/';

export const AssoicadoLoginPath: string = basePath + 'login/';
const AssociadoLoginRoute: IRoute = {
  path: AssoicadoLoginPath,
  exact: true,
  component: AssociadoLogin,
};
routes.push(AssociadoLoginRoute);

const AssociadoRoute: IRoute = {
  path: AssociadoRoutePath,
  component: AssoicadoApp,
};
routes.push(AssociadoRoute);
// export const MainRoutePath = basePath;
// export const MainRoute: IRoute = {
//   path: MainRoutePath,
//   component: Consulta,
//   exact: true,
// };
// routes.push(MainRoute);

export const MainRoutePath: string = basePath;
export const MainRoute: IRoute = {
  path: MainRoutePath,
  component: Main,
  exact: true,
};
routes.push(MainRoute);

export const MainAssessorRoutePath: string = AssessorRoutePath;
export const MainAssessorRoute: IRoute = {
  path: MainAssessorRoutePath,
  component: HomeAssessor,
  exact: true,
  private: true,
};
routes.push(MainAssessorRoute);

export const MensagensAssessorRoutePath: string = AssessorRoutePath + 'mensagens/:idEvento';
export const MensagensAssessorRoute: IRoute = {
  path: MensagensAssessorRoutePath,
  component: MensagensAssessor,
  exact: true,
  private: true,
};
routes.push(MensagensAssessorRoute);

export const ConvocadosAssessorRoutePath: string = AssessorRoutePath + 'convocados/:id';
export const ConvocadosAssessorRoute: IRoute = {
  path: ConvocadosAssessorRoutePath,
  component: ConvocadosAssessor,
  exact: true,
  private: true,
};
routes.push(ConvocadosAssessorRoute);
export const VotoCanalVozPath: string = AssessorRoutePath + 'votoCanalVoz/:idAssembleia';
export const VotoCanalVozRoute: IRoute = {
  path: VotoCanalVozPath,
  component: VotoCanalVoz,
  exact: true,
  private: true,
};
routes.push(VotoCanalVozRoute);

export const EfetivacaoVotacaoPath: string = AssessorRoutePath + ':idAssembleia/pessoa/:cpfRepresentante/pautas';
export const EfetivacaoVotacaoRoute: IRoute = {
  path: EfetivacaoVotacaoPath,
  component: EfetivacaoVotacao,
  exact: true,
  private: true,
};
routes.push(EfetivacaoVotacaoRoute);

export const RelatorioPresentesRoutePath: string =
  AssessorRoutePath + 'assembleia/:idAssembleia/presentes';
export const RelatorioPresenterRoute: IRoute = {
  path: RelatorioPresentesRoutePath,
  component: RelatorioPresentes,
  exact: true,
  private: true,
};
routes.push(RelatorioPresenterRoute);

export const AssembleiaAssociadoRoutePath: string =
  AssociadoRoutePath + 'assembleia/:id/';

export const AssembleiaAssessorRoutePath: string =
  AssessorRoutePath + 'assembleia/:id/';
export const AssembleiaAssessorRoute: IRoute = {
  path: AssembleiaAssessorRoutePath,
  component: AssembleiaAssessor,
  exact: true,
  private: true
};
routes.push(AssembleiaAssessorRoute);

export const AssessorTransmissaoRoutePath: string = AssessorRoutePath + 'transmissao';
export const AssessorTransmissaoRoute: IRoute = {
  path: AssessorTransmissaoRoutePath,
  component: TransmissaoAssessor,
  exact: true,
  private: true,
};
routes.push(AssessorTransmissaoRoute);

export const LogoutRoutePath: string = basePath + 'logout/';
export const LogoutRoute: IRoute = {
  component: Logout,
  private: true
};
routes.push(LogoutRoute);

export const Error404Route: IRoute = {
  component: Error404,
};
routes.push(Error404Route);

export function getRouteComponent(route: IRoute, index: number) {
  return route.private ? (
    <PrivateRoute
      key={index}
      path={route.path || undefined}
      // render={typeof route.render === 'function' ? () => route.render() : null}
      component={route.component}
      exact={route.exact}
    />
  ) : (
    <Route
      key={index}
      path={route.path || undefined}
      // render={typeof route.render === 'function' ? () => route.render() : null}
      component={route.component}
      exact={route.exact}
    />
  );
}

export function getAllRouteComponents() {
  return routes.map((route, index) => getRouteComponent(route, index));
}
